import React from "react";
import { useParams } from "react-router-dom";
import {
  apiCallPost,
  initials,
  niceDateTime,
  renderCorrectedIop,
  yearFromNow,
} from "../util/util";
import "../PrescriptionNew.css";
import QRCode from "react-qr-code";
import {
  AnchorButton,
  Button,
  ControlGroup,
  Icon,
  NonIdealState,
  Spinner,
  Tag,
} from "@blueprintjs/core";
import _ from "lodash";
import SingleSelectWrapper from "../util/SingleSelectWrapper";
import cogoToast from "cogo-toast";
import { nanoid } from "nanoid";

function withRouter(Component) {
  function ComponentWithRouter(props) {
    let params = useParams();
    return <Component {...props} params={params} />;
  }
  return ComponentWithRouter;
}
class RxNewLO extends React.Component {
  state = {
    isLoading: true,
    isFailure: false,
    translatedTexts: [],
    isTranslating: false,
    selectedLanguageForTranslation: "",
  };
  languages = [
    {
      language: "Afrikaans",
      languageCode: "af",
    },
    {
      language: "Albanian",
      languageCode: "sq",
    },
    {
      language: "Amharic",
      languageCode: "am",
    },
    {
      language: "Arabic",
      languageCode: "ar",
    },
    {
      language: "Armenian",
      languageCode: "hy",
    },
    {
      language: "Assamese",
      languageCode: "as",
    },
    {
      language: "Aymara",
      languageCode: "ay",
    },
    {
      language: "Azerbaijani",
      languageCode: "az",
    },
    {
      language: "Bambara",
      languageCode: "bm",
    },
    {
      language: "Basque",
      languageCode: "eu",
    },
    {
      language: "Belarusian",
      languageCode: "be",
    },
    {
      language: "Bengali",
      languageCode: "bn",
    },
    {
      language: "Bhojpuri",
      languageCode: "bho",
    },
    {
      language: "Bosnian",
      languageCode: "bs",
    },
    {
      language: "Bulgarian",
      languageCode: "bg",
    },
    {
      language: "Catalan",
      languageCode: "ca",
    },
    {
      language: "Cebuano",
      languageCode: "ceb",
    },
    {
      language: "Chinese (Simplified)",
      languageCode: "zh",
    },
    {
      language: "Corsican",
      languageCode: "co",
    },
    {
      language: "Croatian",
      languageCode: "hr",
    },
    {
      language: "Czech",
      languageCode: "cs",
    },
    {
      language: "Danish",
      languageCode: "da",
    },
    {
      language: "Dhivehi",
      languageCode: "dv",
    },
    {
      language: "Dogri",
      languageCode: "doi",
    },
    {
      language: "Dutch",
      languageCode: "nl",
    },
    {
      language: "English",
      languageCode: "en",
    },
    {
      language: "Esperanto",
      languageCode: "eo",
    },
    {
      language: "Estonian",
      languageCode: "et",
    },
    {
      language: "Ewe",
      languageCode: "ee",
    },
    {
      language: "Filipino (Tagalog)",
      languageCode: "fil",
    },
    {
      language: "Finnish",
      languageCode: "fi",
    },
    {
      language: "French",
      languageCode: "fr",
    },
    {
      language: "Frisian",
      languageCode: "fy",
    },
    {
      language: "Galician",
      languageCode: "gl",
    },
    {
      language: "Georgian",
      languageCode: "ka",
    },
    {
      language: "German",
      languageCode: "de",
    },
    {
      language: "Greek",
      languageCode: "el",
    },
    {
      language: "Guarani",
      languageCode: "gn",
    },
    {
      language: "Gujarati",
      languageCode: "gu",
    },
    {
      language: "Haitian Creole",
      languageCode: "ht",
    },
    {
      language: "Hausa",
      languageCode: "ha",
    },
    {
      language: "Hawaiian",
      languageCode: "haw",
    },
    {
      language: "Hebrew",
      languageCode: "he",
    },
    {
      language: "Hindi",
      languageCode: "hi",
    },
    {
      language: "Hmong",
      languageCode: "hmn",
    },
    {
      language: "Hungarian",
      languageCode: "hu",
    },
    {
      language: "Icelandic",
      languageCode: "is",
    },
    {
      language: "Igbo",
      languageCode: "ig",
    },
    {
      language: "Ilocano",
      languageCode: "ilo",
    },
    {
      language: "Indonesian",
      languageCode: "id",
    },
    {
      language: "Irish",
      languageCode: "ga",
    },
    {
      language: "Italian",
      languageCode: "it",
    },
    {
      language: "Japanese",
      languageCode: "ja",
    },
    {
      language: "Javanese",
      languageCode: "jv",
    },
    {
      language: "Kannada",
      languageCode: "kn",
    },
    {
      language: "Kazakh",
      languageCode: "kk",
    },
    {
      language: "Khmer",
      languageCode: "km",
    },
    {
      language: "Kinyarwanda",
      languageCode: "rw",
    },
    {
      language: "Konkani",
      languageCode: "gom",
    },
    {
      language: "Korean",
      languageCode: "ko",
    },
    {
      language: "Krio",
      languageCode: "kri",
    },
    {
      language: "Kurdish",
      languageCode: "ku",
    },
    {
      language: "Kurdish (Sorani)",
      languageCode: "ckb",
    },
    {
      language: "Kyrgyz",
      languageCode: "ky",
    },
    {
      language: "Lao",
      languageCode: "lo",
    },
    {
      language: "Latin",
      languageCode: "la",
    },
    {
      language: "Latvian",
      languageCode: "lv",
    },
    {
      language: "Lingala",
      languageCode: "ln",
    },
    {
      language: "Lithuanian",
      languageCode: "lt",
    },
    {
      language: "Luganda",
      languageCode: "lg",
    },
    {
      language: "Luxembourgish",
      languageCode: "lb",
    },
    {
      language: "Macedonian",
      languageCode: "mk",
    },
    {
      language: "Maithili",
      languageCode: "mai",
    },
    {
      language: "Malagasy",
      languageCode: "mg",
    },
    {
      language: "Malay",
      languageCode: "ms",
    },
    {
      language: "Malayalam",
      languageCode: "ml",
    },
    {
      language: "Maltese",
      languageCode: "mt",
    },
    {
      language: "Maori",
      languageCode: "mi",
    },
    {
      language: "Marathi",
      languageCode: "mr",
    },
    {
      language: "Meiteilon (Manipuri)",
      languageCode: "mni-Mtei",
    },
    {
      language: "Mizo",
      languageCode: "lus",
    },
    {
      language: "Mongolian",
      languageCode: "mn",
    },
    {
      language: "Myanmar (Burmese)",
      languageCode: "my",
    },
    {
      language: "Nepali",
      languageCode: "ne",
    },
    {
      language: "Norwegian",
      languageCode: "no",
    },
    {
      language: "Nyanja (Chichewa)",
      languageCode: "ny",
    },
    {
      language: "Odia (Oriya)",
      languageCode: "or",
    },
    {
      language: "Oromo",
      languageCode: "om",
    },
    {
      language: "Pashto",
      languageCode: "ps",
    },
    {
      language: "Persian",
      languageCode: "fa",
    },
    {
      language: "Polish",
      languageCode: "pl",
    },
    {
      language: "Portuguese (Portugal, Brazil)",
      languageCode: "pt",
    },
    {
      language: "Punjabi",
      languageCode: "pa",
    },
    {
      language: "Quechua",
      languageCode: "qu",
    },
    {
      language: "Romanian",
      languageCode: "ro",
    },
    {
      language: "Russian",
      languageCode: "ru",
    },
    {
      language: "Samoan",
      languageCode: "sm",
    },
    {
      language: "Sanskrit",
      languageCode: "sa",
    },
    {
      language: "Scots Gaelic",
      languageCode: "gd",
    },
    {
      language: "Sepedi",
      languageCode: "nso",
    },
    {
      language: "Serbian",
      languageCode: "sr",
    },
    {
      language: "Sesotho",
      languageCode: "st",
    },
    {
      language: "Shona",
      languageCode: "sn",
    },
    {
      language: "Sindhi",
      languageCode: "sd",
    },
    {
      language: "Sinhala (Sinhalese)",
      languageCode: "si",
    },
    {
      language: "Slovak",
      languageCode: "sk",
    },
    {
      language: "Slovenian",
      languageCode: "sl",
    },
    {
      language: "Somali",
      languageCode: "so",
    },
    {
      language: "Spanish",
      languageCode: "es",
    },
    {
      language: "Sundanese",
      languageCode: "su",
    },
    {
      language: "Swahili",
      languageCode: "sw",
    },
    {
      language: "Swedish",
      languageCode: "sv",
    },
    {
      language: "Tagalog (Filipino)",
      languageCode: "tl",
    },
    {
      language: "Tajik",
      languageCode: "tg",
    },
    {
      language: "Tamil",
      languageCode: "ta",
    },
    {
      language: "Tatar",
      languageCode: "tt",
    },
    {
      language: "Telugu",
      languageCode: "te",
    },
    {
      language: "Thai",
      languageCode: "th",
    },
    {
      language: "Tigrinya",
      languageCode: "ti",
    },
    {
      language: "Tsonga",
      languageCode: "ts",
    },
    {
      language: "Turkish",
      languageCode: "tr",
    },
    {
      language: "Turkmen",
      languageCode: "tk",
    },
    {
      language: "Twi (Akan)",
      languageCode: "ak",
    },
    {
      language: "Ukrainian",
      languageCode: "uk",
    },
    {
      language: "Urdu",
      languageCode: "ur",
    },
    {
      language: "Uyghur",
      languageCode: "ug",
    },
    {
      language: "Uzbek",
      languageCode: "uz",
    },
    {
      language: "Vietnamese",
      languageCode: "vi",
    },
    {
      language: "Welsh",
      languageCode: "cy",
    },
    {
      language: "Xhosa",
      languageCode: "xh",
    },
    {
      language: "Yiddish",
      languageCode: "yi",
    },
    {
      language: "Yoruba",
      languageCode: "yo",
    },
    {
      language: "Zulu",
      languageCode: "zu",
    },
  ];
  site_info = {
    hospital_contact: [
      "Dristi Disha Eye Care, LLP",
      "32/1/1, Haldar Para Lane,",
      "Howrah - 711101, WB",
      "(033) 2640 5687 | (033) 6636 0016",
    ],
    _id: "60c8ace65df67754ca63df5a",
    site: "Howrah",
    branchCode: "HWH",
    hospital_name: "Dristi Disha Eye Care",
    ClinicPh: "8336973338",
    InsurancePh: "+919903034378",
    EyeBankPh: "+919830323021/14",
    email: "dristidishahowrah@gmail.com",
    logoUrl:
      "https://newclouds-static.s3.ap-south-1.amazonaws.com/dristi-logo.png",
    buildings: [
      {
        floors: ["Ground Floor", "First Floor", "Second Floor"],
        name: "Howrah",
        numFloors: 1,
      },
    ],
    numBuildings: 1,
    affliation: "5fd1ccd11c831ff79460601e",
    website: "www.dishaeye.org",
  };
  componentDidMount() {
    let ss = this.props.params.visitId;
    if (ss) {
      this.getSubmission(ss);
    } else {
      this.setState({ isLoading: false, isInvalid: true });
    }
  }
  getSubmission = async (ss) => {
    try {
      let res = await apiCallPost("/print/clinical", {
        visitId: ss,
      });
      this.setState({
        site_info: res.branchInfo,
        clinical: res,
        isLoading: false,
      });
    } catch (err) {
      cogoToast.error("Failed to load clinical data.");
      this.setState({ isLoading: false, isFailure: true });
    }
  };
  translate = async (_id, text) => {
    if (!this.state.selectedLanguageForTranslation) {
      cogoToast.error("Translation language not selected.");
      return null;
    }
    let idx = _.findIndex(
      this.languages,
      (x) => x.language === this.state.selectedLanguageForTranslation
    );
    let targetLanguage = this.languages[idx].languageCode;
    try {
      this.setState({ isTranslating: true });
      let res = await apiCallPost(`/util/translate`, {
        text: text,
        tgtLanguage: targetLanguage,
      });
      let tt = this.state.translatedTexts;
      tt.push({
        _id: _id,
        text: res.translatedText,
      });
      this.setState({ translatedTexts: tt, isTranslating: false });
    } catch (err) {
      this.setState({ isTranslating: false });
      cogoToast.error("Failed to translate.");
    }
  };
  renderHeader = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div style={{ fontSize: "large" }}>
          {this.renderHospitalName(
            _.upperCase(this.state.site_info.hospital_name)
          )}
        </div>
        <div style={{ fontSize: "large" }}>
          <b>{_.startCase(_.lowerCase(this.state.clinical.landing.name))}</b>
        </div>
      </div>
    );
  };
  renderLanguageSelector = () => {
    return (
      <SingleSelectWrapper
        showSelectProp={true}
        items={this.languages.map((each) => each.language)}
        selectedItem={this.state.selectedLanguageForTranslation}
        onChange={(item) => {
          this.setState({ selectedLanguageForTranslation: item });
        }}
      />
    );
  };
  /** History */
  renderHospitalName = (text, borderRight = false) => {
    return (
      <div
        style={{
          marginTop: "10px",
          backgroundColor: "#E6E7E7",
          marginBottom: "10px",
          fontSize: "large",
          letterSpacing: "1mm",
          borderLeft: `${borderRight ? "" : "4px solid #000"}`,
          borderRight: `${!borderRight ? "" : "3px solid #aaa"}`,
        }}
      >
        &nbsp;{text}
        {borderRight ? <>&nbsp;</> : ""}
      </div>
    );
  };
  renderHorizontalText = (text, borderRight = false) => {
    return (
      <div
        style={{
          marginTop: "5px",
          backgroundColor: "#E6E7E7",
          marginBottom: "5px",
          fontSize: "small",
          letterSpacing: "1mm",
          borderLeft: `${borderRight ? "" : "3px solid #aaa"}`,
          borderRight: `${!borderRight ? "" : "3px solid #aaa"}`,
        }}
      >
        &nbsp;{text}
        {borderRight ? <>&nbsp;</> : ""}
      </div>
    );
  };
  renderHistoryContext = () => {
    let historyArray = [];
    let functionalEyes = this.state.clinical.landing.functionalEyes;
    let functionalEyesString = "";
    if (functionalEyes !== "Both Eyes") {
      functionalEyesString = functionalEyes;
    }
    if (functionalEyesString) {
      historyArray.push({
        type: "Functional Eyes",
        value: functionalEyesString,
        renderType: "LINE",
      });
    }
    let allergies = this.state.clinical.landing.allergies.map(
      (each) => each.allergy
    );
    let allergyString = allergies.join(", ");
    if (allergyString) {
      let typeString = "Allergy";
      if (allergies.length > 1) {
        typeString = "Allergies";
      }
      historyArray.push({
        type: typeString,
        value: allergyString,
        renderType: "LINE",
      });
    }
    let famHist = this.state.clinical.landing.famHist.map((each) => {
      if (!each.lineage) {
        return each.disease;
      } else {
        return `${each.disease} (${each.lineage})`;
      }
    });
    let famHistString = famHist.join(", ");
    if (famHistString) {
      historyArray.push({
        type: "Family History",
        value: famHistString,
        renderType: "LINE",
      });
    }

    let sysDx = this.state.clinical.landing.sysDx.map((each) => {
      return each.disease + (each.since ? ` (${each.since})` : "");
    });
    let sysDxString = sysDx.join(", ");
    if (sysDxString) {
      historyArray.push({
        type: "Systemic Diseases",
        value: sysDxString,
        renderType: "LINE",
      });
    }

    let sysSx = this.state.clinical.landing.sysSx.map((each) => {
      return each.surgery + (each.when ? ` in ${each.when}` : "");
    });
    let sysSxString = sysSx.join(", ");
    if (sysSxString) {
      historyArray.push({
        type: "Previous Systemic Surgeries",
        value: sysSxString,
        renderType: "LINE",
      });
    }
    let prev_medicines =
      this.state.clinical.landing.todayVisit.prev_medicines.map(
        (each) => each.molecules
      );
    let prev_medicinesString = prev_medicines.join(", ");
    if (prev_medicinesString) {
      historyArray.push({
        type: "Current Medications Prior To Visit",
        value: prev_medicinesString,
        renderType: "LINE",
      });
    }
    let prevEyeDx = this.state.clinical.landing.prevEyeDx.map((each) => {
      if (each.site) {
        return `${initials(each.site)}: ${each.disease}`;
      } else {
        return each.disease;
      }
    });
    let prevEyeDxString = prevEyeDx.join(", ");
    if (prevEyeDxString) {
      historyArray.push({
        type: "Previous Eye Diseases",
        value: prevEyeDxString,
        renderType: "LINE",
      });
    }
    let sysEyeSx = this.state.clinical.landing.sysEyeSx.map((each) => {
      return (
        (each.eye ? initials(each.eye) + " - " : "") +
        each.surgery +
        (each.anaesthesia ? ` ↓ ${initials(each.anaesthesia)}` : "") +
        (each.outsideDoc ? ` - ${each.outsideDoc}` : "") +
        (each.when ? ` - ${each.when}` : "")
      );
    });
    let sysEyeSxString = sysEyeSx.join(", ");
    if (sysEyeSxString) {
      historyArray.push({
        type: "Previous Eye Surgeries",
        value: sysEyeSxString,
        data: sysEyeSx,
        renderType: "TABLE",
      });
    }
    let sym = [];

    let symState = this.state.clinical.landing.todayVisit.symptoms;
    sym = [...symState];
    let notes = this.state.clinical.landing.todayVisit.subjectiveNotes;
    if (notes[0].text) {
      sym.push({ site: "", symptom: notes[0].text });
    }
    let symString = sym.map((each) => {
      let siteString = "";
      if (each.site === "S") {
        siteString = "";
      } else if (!each.site) {
        siteString = "";
      } else {
        siteString = `${each.site} - `;
      }
      return `${siteString}${each.symptom}${
        each.onset ? ` - ${each.onset}` : ""
      }${each.progression ? ` - ${each.progression}` : ""}${
        each.duration ? ` - ${each.duration}` : ""
      }${each.sinceLastVisit ? ` - ${each.sinceLastVisit}` : ""}`;
    });
    if (symString.length) {
      historyArray.push({
        type: "Reason for Today's Visit",
        value: symString.join("; "),
        renderType: "TABLE",
        data: symString,
      });
    }
    if (!historyArray.length) {
      return null;
    } else {
      return (
        <div style={{ marginBottom: "10px" }}>
          <>{this.renderHorizontalText("HISTORY & CONTEXT OF VISIT")}</>
          <div style={{ marginTop: "10px" }}>
            {historyArray.map((each) => {
              if (each.renderType === "LINE") {
                return (
                  <div
                    style={{ marginBottom: "5px" }}
                    className="history_smaller_font"
                  >
                    <b>{each.type}</b>: {each.value}
                  </div>
                );
              } else if (each.renderType === "TABLE") {
                return (
                  <div style={{ marginBottom: "5px" }}>
                    <table className="bp4-html-table bp4-html-table-condensed  work_up_table">
                      <thead></thead>
                      <tbody>
                        {each.data.map((eachData, dataIndex) => {
                          return (
                            <tr index={dataIndex}>
                              {dataIndex === 0 ? (
                                <th
                                  rowSpan={each.data.length}
                                  className="work_up_table_header_row"
                                >
                                  {each.type}
                                </th>
                              ) : null}
                              <td className="work_up_table_body_row">
                                {eachData}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                );
              } else {
                return null;
              }
            })}
          </div>
        </div>
      );
    }
  };
  renderFnDxInv = () => {
    return (
      <div>
        <>{this.renderHorizontalText("EXAMINATION")}</>
        <div>{this.renderFindings()}</div>
      </div>
    );
  };
  renderDx = () => {
    let eyeDx = this.state.clinical.landing.todayVisit.eyeDx;
    if (!eyeDx.length) {
      return null;
    }

    return eyeDx.map((eachDx, dxIndex) => {
      return (
        <tr className="override_top_border">
          {dxIndex === 0 && (
            <th
              className="work_up_table_header_row override_top_border"
              rowSpan={eyeDx.length}
            >
              Diagnosis
            </th>
          )}
          <td
            colSpan={2}
            className="work_up_table_body_row override_top_border"
          >
            {eachDx.site ? `${initials(eachDx.site)} - ` : ""}
            {eachDx.query ? "?" : ""}
            {eachDx.disease}
          </td>
        </tr>
      );
    });
  };
  renderInv = () => {
    let investigations = this.state.clinical.investigations;

    let sysInvestigations = this.state.clinical.landing.todayVisit.sysinv;
    if (sysInvestigations.length) {
      let sysInvArray = sysInvestigations.map((each) => {
        let value = "";
        if (each.typeOfTest === "Quantitative") {
          value = each.value + " " + (each.unit || "");
        } else if (each.typeOfTest === "Boolean") {
          value = each.value ? "Positive/Detected" : "Negative/Not Detected";
        } else if (each.typeOfTest === "Narrative") {
          value = each.value;
        }
        return {
          eye: "",
          type: each.testName,
          notes: value,
        };
      });
      investigations = [...investigations, ...sysInvArray];
    }
    if (!investigations.length) {
      return null;
    }

    return investigations.map((eachInv, dxIndex) => {
      let subtypeString = "";
      if (!eachInv.subtype) {
      } else if (eachInv.subtype === "Generic") {
      } else {
        subtypeString = eachInv.subtype;
      }
      return (
        <tr>
          {dxIndex === 0 && (
            <th
              className="work_up_table_header_row"
              rowSpan={investigations.length}
            >
              Procedures & Investigations
            </th>
          )}
          <td colSpan={2} className="work_up_table_body_row">
            {eachInv.eye ? `${initials(eachInv.eye)} - ` : ""} {eachInv.type}
            {subtypeString ? ` (${subtypeString})` : ""}
            {eachInv.notes ? ` - ${eachInv.notes}` : ""}
          </td>
        </tr>
      );
    });
  };
  renderFindings = () => {
    let findings = this.state.clinical.landing.todayVisit.findings;
    let findingNotes = this.state.clinical.landing.todayVisit.findingNotes
      .map((each) => each.text)
      .filter(Boolean);

    let notes = this.state.clinical.landing.todayVisit.dxNotes
      .map((each) => each.text)
      .filter(Boolean);
    let totalNotes = _.flatten(_.concat(findingNotes, notes)).join(" ;");
    return (
      <div
        style={{
          marginBottom: "10px",
        }}
      >
        <div>
          <table className="bp4-html-table bp4-html-table-condensed  bp4-html-table-striped fnd_table">
            <thead></thead>
            <tbody>
              {this.renderDx()}
              <tr>
                <th className="work_up_table_header_row">Findings</th>
                <th>Right Eye</th>
                <th>Left Eye</th>
              </tr>
              {this.renderFindingsTable(findings)}
              {this.renderInv()}
            </tbody>
          </table>
          <div>{totalNotes}</div>
        </div>
      </div>
    );
  };
  renderFindingsTable = (findings) => {
    let functionalEyes = this.state.clinical.landing.functionalEyes;
    let asn = this.state.clinical.landing.todayVisit.areSectionsNormal;

    for (var i = 0; i < asn.length; i++) {
      let arr = [];
      if (["Both Eyes", "Right Eye"].includes(functionalEyes)) {
        arr.push({ site: "Right Eye", item: "No specific observations" });
      }
      if (["Both Eyes", "Left Eye"].includes(functionalEyes)) {
        arr.push({ site: "Left Eye", item: "No specific observations" });
      }
      let which = asn[i];
      findings[which] = arr;
    }
    let keys = _.keys(findings);
    return keys.map((each) => {
      if (findings[each].length) {
        let r = _.filter(findings[each], (x) => x.site === "Right Eye").length;
        let l = _.filter(findings[each], (x) => x.site === "Left Eye").length;
        let rString = "";
        let lString = "";
        if (r === 0) {
          if (["Both Eyes", "Right Eye"].includes(functionalEyes)) {
            rString = " ";
          }
        }
        if (l === 0) {
          if (["Both Eyes", "Left Eye"].includes(functionalEyes)) {
            lString = " ";
          }
        }
        return (
          <tr>
            <td>{each}</td>
            <td>
              {_.filter(findings[each], (x) => x.site === "Right Eye")
                .map((f) => {
                  return (
                    f.item +
                    (f.qualifier ? ` - ${f.qualifier}` : "") +
                    (f.sinceLastVisit
                      ? ` - ${f.sinceLastVisit} since the last visit`
                      : "") +
                    (f.splText ? ` - ${f.splText}` : "")
                  );
                })
                .join("; ") || rString}{" "}
            </td>
            <td>
              {_.filter(findings[each], (x) => x.site === "Left Eye")
                .map((f) => {
                  return (
                    f.item +
                    (f.qualifier ? ` - ${f.qualifier}` : "") +
                    (f.sinceLastVisit
                      ? ` - ${f.sinceLastVisit} since the last visit`
                      : "") +
                    (f.splText ? ` - ${f.splText}` : "")
                  );
                })
                .join("; ") || lString}{" "}
            </td>
          </tr>
        );
      } else {
        return null;
      }
    });
  };
  /**Findings End */
  renderPrescriptionArea = () => {
    return (
      <div>
        {this.renderMedicines()} {this.renderSx()}
        {this.renderAdvice()}
      </div>
    );
  };
  renderMedicines = () => {
    let meds = this.state.clinical.landing.todayVisit.medicines;
    if (!meds.length) {
      return null;
    }
    return (
      <div>
        <>{this.renderHorizontalText("PRESCRIPTION (MEDICINES)")}</>
        <table className="bp4-html-table bp4-html-table-condensed med_table">
          <thead></thead>
          <tbody>
            {meds.map((each) => {
              let translatedText = "";
              let idx = _.findIndex(
                this.state.translatedTexts,
                (x) => x._id === each._id
              );
              if (idx > -1) {
                translatedText = this.state.translatedTexts[idx].text;
              }
              return (
                <tr>
                  <td className="work_up_table_header_row">
                    {each.route}
                    <b> {`${each.brand}`} </b> ({each.molecules})
                  </td>
                  <td className="work_up_table_body_row">
                    <>
                      {each.eye === "RE" ? (
                        <>
                          <Icon icon="eye-on" /> <Icon icon="eye-off" /> Right
                          Eye -{" "}
                        </>
                      ) : each.eye === "LE" ? (
                        <>
                          <Icon icon="eye-off" /> <Icon icon="eye-on" /> Left
                          Eye -{" "}
                        </>
                      ) : each.eye === "BE" ? (
                        <>
                          <Icon icon="eye-on" /> <Icon icon="eye-on" /> Both
                          Eyes -{" "}
                        </>
                      ) : null}
                      {each.durationText.includes(",") ? (
                        <>
                          {each.durationText.split(", ").map((x) => (
                            <div>{x}</div>
                          ))}
                        </>
                      ) : (
                        <>
                          {each.durationText}
                          {translatedText ? (
                            <>
                              <br />
                              {translatedText}
                            </>
                          ) : null}
                        </>
                      )}
                    </>
                  </td>
                  <td className="pres-no__print">
                    {translatedText ? (
                      <Button
                        minimal
                        icon="translate"
                        intent="danger"
                        rightIcon="delete"
                        onClick={() => {
                          let tt = this.state.translatedTexts;
                          _.remove(tt, (x) => x._id === each._id);
                          this.setState({ translatedTexts: tt });
                        }}
                      />
                    ) : (
                      <Button
                        loading={this.state.isTranslating}
                        minimal
                        icon="translate"
                        onClick={() => {
                          this.translate(
                            each._id,
                            `${
                              each.eye === "RE"
                                ? "Right Eye - "
                                : each.eye === "LE"
                                ? "Left Eye - "
                                : each.eye === "BE"
                                ? "Both Eyes - "
                                : ""
                            }${each.durationText}`
                          );
                        }}
                      />
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };
  renderAdvice = () => {
    let advArray = [];
    let adv = this.state.clinical.landing.todayVisit.advice;
    if (adv.length) {
      advArray = [...adv];
    }
    if (this.state.clinical.landing.todayVisit.advNotes[0].text) {
      advArray = [
        ...advArray,
        ...this.state.clinical.landing.todayVisit.advNotes,
      ];
    }

    if (this.state.clinical.landing.todayVisit.vision.glassAdvice.length) {
      let tt = this.state.clinical.landing.todayVisit.vision.glassAdvice;
      if (tt.includes("Contact Lenses")) {
        _.remove(tt, (each) => each === "Contact Lenses");
        advArray.push({ text: "Contact lenses prescribed." });
      }
      if (tt.length) {
        let gg = tt.join(" / ");
        gg += " glasses prescribed.";
        advArray.push({ text: gg });
      }
    }
    if (!advArray.length) {
      return null;
    }
    return (
      <div>
        <>{this.renderHorizontalText("NOTES & ADVICE")}</>
        {advArray.map((each) => {
          let translatedText = "";
          let idx = _.findIndex(
            this.state.translatedTexts,
            (x) => x._id === each._id
          );

          if (idx > -1) {
            translatedText = this.state.translatedTexts[idx].text;
          }
          return (
            <div className="pres-vision__workup__tags">
              <Tag minimal multiline className="pres-font__small pres-bg__none">
                {`${each.text}`}
              </Tag>
              <Tag minimal multiline className="pres-font__small pres-bg__none">
                {each.durationText}
              </Tag>
              {translatedText && (
                <>
                  {" "}
                  <br />
                  <Tag
                    minimal
                    multiline
                    className="pres-font__small pres-bg__none"
                  >
                    {translatedText}
                  </Tag>
                </>
              )}
              {each._id && (
                <div className="pres-no__print">
                  {translatedText ? (
                    <Button
                      minimal
                      icon="translate"
                      intent="danger"
                      rightIcon="delete"
                      onClick={() => {
                        let tt = this.state.translatedTexts;
                        _.remove(tt, (x) => x._id === each._id);
                        this.setState({ translatedTexts: tt });
                      }}
                    />
                  ) : (
                    <Button
                      loading={this.state.isTranslating}
                      minimal
                      icon="translate"
                      onClick={() => {
                        this.translate(
                          each._id,
                          `${each.text} ${each.durationText ? " - " : ""} ${
                            each.durationText || ""
                          }`
                        );
                      }}
                    />
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  };
  renderSx = () => {
    let sx = this.state.clinical.landing.todayVisit.plannedEyeSx.map(
      (each) => each.composeString
    );

    if (!sx.length) {
      return null;
    }
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        {sx.length === 1 ? (
          <b>{this.renderHorizontalText("SURGERY ADVISED")}</b>
        ) : (
          <b>{this.renderHorizontalText("SURGERIES ADVISED")}</b>
        )}
        <div>
          {sx.map((each) => {
            return (
              <div className="pres-vision__workup__tags">
                <Tag
                  minimal
                  multiline
                  className="pres-font__small pres-bg__none"
                >
                  {each}
                </Tag>
              </div>
            );
          })}
        </div>
      </div>
    );
  };
  renderFUDoc = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
        }}
      >
        <div>{this.renderFollowUp()}</div> <div>{this.renderDoc()}</div>
      </div>
    );
  };
  renderFollowUp = () => {
    let fuObj = this.state.clinical.landing.todayVisit.followup[0];
    let fuString = "";
    if (fuObj.refer) {
      if (fuObj.when) {
        fuString = `Referred to ${fuObj.referTo} - ${fuObj.when}. `;
      } else {
        fuString = `Referred to ${fuObj.referTo}. `;
      }
      if (fuObj.referralNote) {
        fuString = fuString + " Note: " + fuObj.referralNote;
      }
    } else {
      if (fuObj.when) {
        fuString = `Follow up with your doctor - ${fuObj.when}.`;
      } else {
        fuString = "";
      }
    }
    let fuWith = this.state.clinical.landing.todayVisit.followupWith.map(
      (each) => {
        let eye = each.eye ? `${initials(each.eye)}: ` : "";
        let st = each.subtype === "Generic" ? "" : ` - ${each.subtype}`;
        return eye + each.type + st + " - " + each.when;
      }
    );
    return (
      <div>
        <>{this.renderHorizontalText("FOLLOW UP")}</>
        {fuString ? (
          <div>{fuString}</div>
        ) : (
          <div>Regular check up recommended.</div>
        )}

        <div>
          Contact the hospital for any issues, pain, discharge, drop of vision
          or discomfort.
        </div>
        <div>
          {fuWith.length ? <b>Follow Up with:</b> : null}
          {fuWith.map((each) => {
            return <div>{each}</div>;
          })}
        </div>
      </div>
    );
  };
  renderDoc = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginBottom: "10px",
          marginLeft: "10px",
          textAlign: "right",
        }}
      >
        <>{this.renderHorizontalText("DOCTOR", true)}</>

        <div>
          <br />
          <br />
          <br />
          <div style={{ fontSize: "medium" }}>
            <b>{this.state.clinical.resource.name}</b>
          </div>
          <div>{this.state.clinical.resource.qualifications}</div>
          <div>Registration: {this.state.clinical.resource.mrNumber}</div>
        </div>
      </div>
    );
  };
  visionMassage = (hasKey, key, current, niceKey) => {
    if (this.state.clinical.landing.todayVisit.vision[hasKey]) {
      let visionDataObject = this.state.clinical.landing.todayVisit.vision[key];
      let visionDataObjectRE = visionDataObject.re;
      let visionDataObjectLE = visionDataObject.le;
      let whichVisionsToRender = [];
      let whichTypesOfVisionWereMeasured = [];

      if (
        visionDataObjectRE.v_dist !== "---" ||
        visionDataObjectLE.v_dist !== "---"
      ) {
        whichTypesOfVisionWereMeasured.push({
          type: "Dist",
          re:
            visionDataObjectRE.v_dist === "---"
              ? ""
              : visionDataObjectRE.v_dist,
          le:
            visionDataObjectLE.v_dist === "---"
              ? ""
              : visionDataObjectLE.v_dist,
        });
      }
      if (
        visionDataObjectRE.v_ph !== "---" ||
        visionDataObjectLE.v_ph !== "---"
      ) {
        whichTypesOfVisionWereMeasured.push({
          type: "PH",
          re: visionDataObjectRE.v_ph === "---" ? "" : visionDataObjectRE.v_ph,
          le: visionDataObjectLE.v_ph === "---" ? "" : visionDataObjectLE.v_ph,
        });
      }
      if (
        visionDataObjectRE.v_near !== "---" ||
        visionDataObjectLE.v_near !== "---"
      ) {
        whichTypesOfVisionWereMeasured.push({
          type: "Near",
          re:
            visionDataObjectRE.v_near === "---"
              ? ""
              : visionDataObjectRE.v_near,
          le:
            visionDataObjectLE.v_near === "---"
              ? ""
              : visionDataObjectLE.v_near,
        });
      }
      if (whichTypesOfVisionWereMeasured.length) {
        whichVisionsToRender.push({
          type: niceKey,
          data: whichTypesOfVisionWereMeasured,
        });
      }
      return [...current, ...whichVisionsToRender];
    }
    return current;
  };
  iopMassage = () => {
    let visionObj = this.state.clinical.landing.todayVisit.vision;
    let hasAnyIOP = false;
    let hasNCT = false;
    let hasAT = false;
    if (visionObj.nct.le !== "---" && visionObj.nct.le !== 0) {
      hasNCT = true;
      hasAnyIOP = true;
    }
    if (visionObj.nct.re !== "---" && visionObj.nct.re !== 0) {
      hasNCT = true;
      hasAnyIOP = true;
    }
    if (visionObj.at.le !== "---" && visionObj.at.le !== 0) {
      hasAT = true;
      hasAnyIOP = true;
    }
    if (visionObj.at.re !== "---" && visionObj.at.re !== 0) {
      hasAT = true;
      hasAnyIOP = true;
    }

    if (hasAnyIOP) {
      let whichIOPsToRender = [
        {
          type: "IOP",
          data: [],
        },
      ];
      if (hasNCT) {
        let type = "NCT (mm Hg)";
        let re = visionObj.nct.re === "---" ? "" : visionObj.nct.re;
        let le = visionObj.nct.le === "---" ? "" : visionObj.nct.le;
        if (visionObj.cct.re && re) {
          re += ` (${renderCorrectedIop(visionObj.cct.re, re)})`;
          whichIOPsToRender[0].type = "IOP (Adjusted for CCT)";
        }
        if (visionObj.cct.le && le) {
          le += ` (${renderCorrectedIop(visionObj.cct.le, le)})`;
          whichIOPsToRender[0].type = "IOP (Adjusted for CCT)";
        }
        whichIOPsToRender[0].data.push({
          type: type,
          re: re,
          le: le,
        });
      }
      if (hasAT) {
        let type = "AT (mm Hg)";
        let re = visionObj.at.re === "---" ? "" : visionObj.at.re;
        let le = visionObj.at.le === "---" ? "" : visionObj.at.le;
        if (visionObj.cct.re && re) {
          re += ` (${renderCorrectedIop(visionObj.cct.re, re)})`;
          whichIOPsToRender[0].type = "IOP (Adjusted for CCT)";
        }
        if (visionObj.cct.le && le) {
          le += ` (${renderCorrectedIop(visionObj.cct.le, le)})`;
          whichIOPsToRender[0].type = "IOP (Adjusted for CCT)";
        }
        whichIOPsToRender[0].data.push({
          type: type,
          re: re,
          le: le,
        });
      }
      return whichIOPsToRender;
    }
  };
  otherWorkUpMassage = () => {
    let visionObj = this.state.clinical.landing.todayVisit.vision;
    let colorVision =
      this.state.clinical.landing.colorVision === "Not Tested"
        ? ""
        : this.state.clinical.landing.colorVision;

    let whichOtherWorkUpsToRender = [];
    if (visionObj.cct.le || visionObj.cct.re) {
      whichOtherWorkUpsToRender.push({
        type: "CCT (µm)",
        data: [
          {
            type: null,
            re: visionObj.cct.re ? `${visionObj.cct.re}` : "",
            le: visionObj.cct.le ? `${visionObj.cct.le}` : "",
          },
        ],
      });
    }
    if (visionObj.pupillaryReaction.le || visionObj.pupillaryReaction.re) {
      whichOtherWorkUpsToRender.push({
        type: "Pupillary Reaction",
        data: [
          {
            type: null,
            re: visionObj.pupillaryReaction.re
              ? `${visionObj.pupillaryReaction.re}`
              : "",
            le: visionObj.pupillaryReaction.le
              ? `${visionObj.pupillaryReaction.le}`
              : "",
          },
        ],
      });
    }
    if (visionObj.schirmer.le || visionObj.schirmer.re) {
      whichOtherWorkUpsToRender.push({
        type: "Schirmer's Test",
        data: [
          {
            type: null,
            re: visionObj.schirmer.re ? `${visionObj.schirmer.re}` : "",
            le: visionObj.schirmer.le ? `${visionObj.schirmer.le}` : "",
          },
        ],
      });
    }
    if (visionObj.contrast.le || visionObj.contrast.re) {
      whichOtherWorkUpsToRender.push({
        type: "Contrast Sensitivity",
        data: [
          {
            type: null,
            re: visionObj.contrast.re ? `${visionObj.contrast.re}` : "",
            le: visionObj.contrast.le ? `${visionObj.contrast.le}` : "",
          },
        ],
      });
    }
    if (visionObj.worth) {
      whichOtherWorkUpsToRender.push({
        type: "Worth's Four Dot Test",
        data: [
          {
            type: null,
            re: visionObj.worth ? `${visionObj.worth}` : "",
            le: "DO_NOT_RENDER",
          },
        ],
      });
    }
    if (colorVision) {
      whichOtherWorkUpsToRender.push({
        type: "Colour Vision",
        data: [
          {
            type: null,
            re: colorVision ? `${colorVision}` : "",
            le: "DO_NOT_RENDER",
          },
        ],
      });
    }
    return whichOtherWorkUpsToRender;
  };
  renderWorkUp = () => {
    let whichVisionsToRender = [];
    whichVisionsToRender = this.visionMassage(
      "has_uncorrected",
      "uncorrected",
      whichVisionsToRender,
      "Uncorrected Vision"
    );
    whichVisionsToRender = this.visionMassage(
      "has_pgp",
      "pgp",
      whichVisionsToRender,
      "Present Glass"
    );
    whichVisionsToRender = this.visionMassage(
      "has_corrected_dry",
      "corrected_dry",
      whichVisionsToRender,
      "Dry Refraction"
    );
    whichVisionsToRender = this.visionMassage(
      "has_corrected_dilated",
      "corrected_dilated",
      whichVisionsToRender,
      "Dilated Refraction"
    );
    whichVisionsToRender = this.visionMassage(
      "has_corrected_pmt",
      "corrected_pmt",
      whichVisionsToRender,
      "PMT"
    );
    whichVisionsToRender = this.visionMassage(
      "has_corrected_rx",
      "corrected_rx",
      whichVisionsToRender,
      "Final Rx"
    );
    let noVision = true;
    if (whichVisionsToRender.length) {
      noVision = false;
    }
    let IOPData = this.iopMassage();
    if (IOPData && IOPData.length && IOPData[0].data.length) {
      whichVisionsToRender.push(IOPData[0]);
    }
    let otherWorkUpData = this.otherWorkUpMassage();
    if (otherWorkUpData.length) {
      whichVisionsToRender = [...whichVisionsToRender, ...otherWorkUpData];
    }
    if (noVision && !whichVisionsToRender.length) {
      if (
        this.state.clinical.landing.todayVisit.vision.notRecordedReason.length
      ) {
        let noVisionReasons =
          this.state.clinical.landing.todayVisit.vision.notRecordedReason.join(
            ", "
          );
        return (
          <div>
            <b>Note:</b> Visual acuity was not recorded because of the following
            factors: {noVisionReasons}
          </div>
        );
      } else {
        return null;
      }
    }
    if (noVision && whichVisionsToRender.length) {
      let noVisionReasons =
        this.state.clinical.landing.todayVisit.vision.notRecordedReason.join(
          ", "
        );
      if (!noVisionReasons) {
      } else {
        noVisionReasons = "Factors: " + noVisionReasons;
        let noVisionData = {
          type: "VA not recorded",
          data: [
            { type: null, re: noVisionReasons || "", le: "DO_NOT_RENDER" },
          ],
        };
        whichVisionsToRender.unshift(noVisionData);
      }
    }

    return (
      <div>
        <>{this.renderHorizontalText("WORK UP & OPTOMETRY")}</>
        <table className="bp4-html-table bp4-html-table-condensed work_up_table">
          <thead>
            <tr>
              <th rowSpan={2}></th>
              {this.renderWorkUpTableTopHeader(whichVisionsToRender)}
            </tr>
            <tr> {this.renderBodyFirstRow(whichVisionsToRender)}</tr>
          </thead>
          <tbody>
            <tr>
              <td>Right Eye</td>
              {this.renderBodyRows(whichVisionsToRender, "re")}
            </tr>
            <tr>
              <td>Left Eye</td>
              {this.renderBodyRows(whichVisionsToRender, "le")}
            </tr>
          </tbody>
        </table>
      </div>
    );
  };
  renderBodyFirstRow = (whichVisionsToRender) => {
    return whichVisionsToRender.map((each) => {
      return each.data.map((eachData, dataIndex) => {
        if (!eachData.type) return null;
        return (
          <td className="work_up_table_header_row" key={dataIndex}>
            {eachData.type}
          </td>
        );
      });
    });
  };
  renderBodyRows = (whichVisionsToRender, whichEye) => {
    return whichVisionsToRender.map((each) => {
      return each.data.map((eachData) => {
        if (whichEye === "le" && eachData["le"] === "DO_NOT_RENDER")
          return null;
        return (
          <React.Fragment key={nanoid()}>
            <td
              className={eachData[whichEye] ? "work_up_table_body_row" : ""}
              rowSpan={
                whichEye === "re" && eachData["le"] === "DO_NOT_RENDER" ? 2 : 1
              }
            >
              {eachData[whichEye]}
            </td>
          </React.Fragment>
        );
      });
    });
  };
  renderWorkUpTableTopHeader = (whichVisionsToRender) => {
    return whichVisionsToRender.map((each) => {
      return (
        <React.Fragment key={nanoid()}>
          <th
            colSpan={each.data.length}
            className="work_up_table_header_row"
            rowSpan={each.data.length === 1 && !each.data[0].type ? 2 : 1}
          >
            {each.type}
          </th>
        </React.Fragment>
      );
    });
  };
  renderPatientBox = () => {
    return (
      <div
        style={{ padding: "5px", border: "1px solid #aaa", marginLeft: "10px" }}
      >
        <table className="bp4-html-table bp4-html-table-condensed  patient_table">
          <thead>
            <tr>
              <td>
                PID: <b>{this.state.clinical.landing.sysPid}</b>
              </td>
            </tr>
            <tr>
              <td>
                {niceDateTime(
                  this.state.clinical.landing.todayVisit.appointmentTime
                )}
              </td>
            </tr>
          </thead>
          <tbody>
            <tr style={{ fontSize: "smaller" }}>
              <td>
                {yearFromNow(this.state.clinical.landing.dob)}
                {" / "}
                {this.state.clinical.landing.sex}
                <br />
                Phone:
                {this.state.clinical.landing.phone}
                <br />
                {this.state.clinical.landing.address.replace(
                  /\w+/g,
                  _.capitalize
                )}
              </td>
            </tr>
            <tr style={{ fontSize: "smaller" }}>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };
  renderTopSection = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{ display: "flex", flexWrap: "wrap", flexDirection: "column" }}
        >
          {" "}
          {this.renderHistoryContext()}
          {this.renderWorkUp()}
        </div>
        <div>{this.renderPatientBox()}</div>
      </div>
    );
  };
  renderFooter = () => {
    return (
      <div>
        <hr />
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
          }}
        >
          <div
            style={{
              marginRight: "5px",
              marginBottom: "5px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              alt="Client Logo"
              src={this.state.site_info.logoUrl}
              height="60px"
              width="auto"
            />
          </div>
          <div style={{ fontSize: "x-small", textAlign: "center" }}>
            <b> {this.state.site_info.hospital_contact[0]}</b> <br />
            {this.state.site_info.hospital_contact[1]}{" "}
            {this.state.site_info.hospital_contact[2]}{" "}
            {this.state.site_info.hospital_contact[3]}
            <br />
            {this.state.site_info.ClinicPh} | {this.state.site_info.email}{" "}
            <br />
            Eye Bank: {this.state.site_info.EyeBankPh} | Insurance:{" "}
            {this.state.site_info.InsurancePh}
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <QRCode
              size={50}
              value={`https://print.newchart.care/rx/${this.props.params.visitId}`}
              level="H"
            />
            <div
              style={{
                fontSize: "x-small",
                wordBreak: "break-all",
                maxWidth: "80px",
                textAlign: "center",
              }}
            >
              <code style={{ textAlign: "center" }}>
                {" "}
                {this.state.clinical.landing.todayVisit._id}
              </code>
            </div>
          </div>
        </div>
      </div>
    );
  };
  render() {
    if (this.state.isLoading) {
      return (
        <div className="pres-center_screen">
          <NonIdealState icon={<Spinner />} title="Loading..." />
        </div>
      );
    }
    if (this.state.isFailure) {
      return (
        <div className="pres-center_screen">
          <NonIdealState
            icon="warning-sign"
            title="We ran into an error. If you face this problem multiple times, please contact support."
          />
        </div>
      );
    }
    return (
      <div className="pres-rx__container">
        <style type="text/css" media="print">
          {" @page { size: A4 portrait !important; margin: 7mm !important;"}
        </style>
        <div>
          <div className="pres-no__print">
            <ControlGroup>
              <Button
                icon="print"
                text="Print"
                onClick={() => {
                  window.print();
                }}
                fill
              />
              <Tag minimal large>
                Translation Target Language
              </Tag>
              {this.renderLanguageSelector()}
              <AnchorButton
                minimal
                icon="double-chevron-left"
                text="Previous Rx Format"
                href={`/rxold/${this.props.params.visitId}`}
                target="_blank"
              />
            </ControlGroup>
          </div>
          {this.renderHeader()}
          <hr />
          {this.renderTopSection()}
          {this.renderFnDxInv()}
          {this.renderPrescriptionArea()}
          {this.renderFUDoc()}
        </div>
        <div> {this.renderFooter()}</div>
      </div>
    );
  }
}

const PrescriptionNew = withRouter(RxNewLO);
export default PrescriptionNew;
